export const getDomain = () => {
  let domain = window.location.protocol + '//' + window.location.hostname;
  if (window.location.port) {
    domain += ':' + window.location.port;
  }
  return domain;
};
